// @ts-strict-ignore
import {promisifyModal} from 'common/components/modal/utils';
import type {CustomEventDefinition} from 'common/report/util/saved-entities/types';
import {Visibility} from 'common/components/base/stackable';

import './index';
import type {CustomEventModalAttrs, CustomEventModalParams} from './index';

export async function promptCustomEvents({
  attrs,
  params,
}: {
  attrs: Omit<CustomEventModalAttrs, `project-id` | `workspace-id`> & {
    // fixes a ts error after adding types. these get stringified anyway in promisifyModal
    'project-id': number | string;
    'workspace-id': number | string;
  };
  params: CustomEventModalParams;
}): Promise<{appliedValue: CustomEventDefinition; didClose: boolean; deletedId: string | number}> {
  const closeEv = await promisifyModal({
    tagName: `mp-custom-event-modal`,
    attrs,
    params,
    closeEvents: [`savedCustomEvent`, `deletedCustomEvent`, `modalClosed`],
  });

  return {
    appliedValue: closeEv.type === `savedCustomEvent` ? closeEv.detail?.customEvent : null,
    didClose:
      closeEv.type === `modalClosed` || (closeEv.type === `change` && closeEv.detail.state === Visibility.Closed),
    deletedId: closeEv.type === `deletedCustomEvent` ? closeEv.detail.id : null,
  };
}
